<template>
    <panel-full :isShowHeader="true" :headTitle="'发布订单须知'" @customMethod="customBack">
        <div class="content-wrap release-clientjob-confirm">
            <div class="release-statement-panel">
                <div class="statement-cont-item">
                    <div class="cont">
                        <p>为了更好的为合作商户服务，保证交易双方的权利，请发布方严格遵守以下几项须知：</p>
                        <p>1、合作商户发布订单不收取任何收费；</p>
                        <p>2、合作商户无须录入客户信息，但须保证订单为一手订单；</p>
                        <p>3、订单信息尽量完整清晰；</p>
                        <p>4、不得发布虚假订单；</p>
                        <p>5、订单发布后，合作商户推荐服务师；</p>
                        <p>6、确定服务师后，合作商户与发布方对接；</p>
                        <p>7、订单结束，发布方须及时完善订单状态。</p>
                    </div>
                    <div class="symbol-panel">
                        <span class="bullet">1</span>
                    </div>
                </div>
                <div class="statement-cont-item">
                    <div class="cont">
                        <p>为了让交易双方都能够积极促成订单，平台自动对合作商户的成交率进行排名，成交率排名越靠前，合作商户推荐服务人员的积极性就越高；反之成交率越低，合作商户推荐服务人员的积极性就越低。</p>
                    </div>
                    <div class="symbol-panel">
                        <span class="bullet">2</span>
                    </div>
                </div>
                <div class="statement-cont-item">
                    <div class="cont">
                        <p>凡发布虚假订单，累计被举报次数达3次，封账号1个月。商户信用度降低一个等级。且需缴纳500元违约金，方可重新开通账户。凡发布虚假订单，累计被举报次数达5次，封账号3个月，商户信用度降低二个等级。且需缴纳1000元违约金，方可重新开通账户。</p>
                    </div>
                    <div class="symbol-panel">
                        <span class="bullet">3</span>
                    </div>
                </div>
            </div>
            <div class="pub-btn-panel release-handle-panel">
                <span class="pub-btn-sub" @click="agree">同意</span>
                <span class="pub-btn-sub disabled" @click="customBack">拒绝</span>
            </div>
        </div>
    </panel-full>
</template>
<style scoped>
.release-clientjob-confirm{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}
.release-statement-panel{
    flex: 1 1 auto;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
}
.statement-cont-item{
    width: 92%;
    padding: 0.3rem 4% 0.2rem;
    border-bottom: 0.12rem solid #f4f5f6;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
}
.statement-cont-item:last-child{
    border: 0;
}
.statement-cont-item .cont{
    flex: 1 1 auto;
    order: 2;
    text-align: left;
    font-size: 0.24rem;
    color: #6a6f71;
    line-height: 0.46rem;
}
.statement-cont-item .symbol-panel{
    flex: 0 0 auto;
    order: 1;
    margin-right: 0.16rem;
    width: 0.3rem;
    position: relative;
}
.statement-cont-item .symbol-panel:after{
    content: "";
    width: 1px;
    background-color: #f0861b;
    position: absolute;
    left: 50%;
    top: 0.1rem;
    bottom: 0.12rem;
    z-index: 1;
}
.statement-cont-item .symbol-panel .bullet{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 0.3rem;
    height: 0.3rem;
    background-color: #f0861b;
    border-radius: 50%;
    text-align: center;
    font-size: 0.24rem;
    color: #ffffff;
    position: absolute;
    left: 0;
    top: 0.08rem;
    z-index: 5;
}
.release-handle-panel{
    flex: 0 0 auto;
    width: 100%;
    margin: 0.6rem auto;
}
</style>
<script>
export default {
    props: {
    },
    methods:{
        //同意
        agree(){
            this.$emit("agree");
        },
        //自定义返回
        customBack(){
            this.$emit("customBack");
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/shared/components/client/release/releaseClientJobConfirm.vue